import './index.scss'

import { initApp, setActiveNav } from 'app/js/app'

setActiveNav()

$(() => {
  initApp()

  const TECH_SUPPORT_URL = 'https://cloud.yunion.cn/account/tech-support'
  const LOGIN_URL = 'https://cloud.yunion.cn/auth/login?source=' + encodeURIComponent(TECH_SUPPORT_URL)
  const COUNTDOWN_SECONDS = 5

  let countdownTimer = null

  function showLoginRequired() {
    const $panel = $('#pts-login-required')
    const $countdown = $('#pts-login-countdown')
    const $loginBtn = $('#pts-login-now')
    let remain = COUNTDOWN_SECONDS

    $loginBtn.attr('href', LOGIN_URL)
    $countdown.text(remain)
    $panel.prop('hidden', false)
    $('body').addClass('pts-login-required-open')

    if (countdownTimer) clearInterval(countdownTimer)
    countdownTimer = setInterval(() => {
      remain -= 1
      if (remain <= 0) {
        clearInterval(countdownTimer)
        countdownTimer = null
        window.location.href = LOGIN_URL
        return
      }
      $countdown.text(remain)
    }, 1000)
  }

  function handleOrderClick() {
    const token = window.Cookies && window.Cookies.get ? window.Cookies.get('yunionauth') : null
    if (!token) {
      showLoginRequired()
      return
    }
    window.location.href = TECH_SUPPORT_URL
  }

  $('#pts-order-btn').on('click', handleOrderClick)
  $('#pts-order-btn-bottom').on('click', handleOrderClick)
})



// WEBPACK FOOTER //
// ./src/paidtechservice/index.js